import React from "react";
import LoginStepComponent from "./components/login.component";
import { useCreateKioskoContext } from "./provider/createKiosko.provider";
import Code2FAStepComponent from "./components/code.component";
import SelectFlowComponent from "./components/select-flow.component";
import RecoverStep from "./components/recover.component";
import { useCreateNewsKioskoContext } from "./provider/createNewsKiosko.provider";
import { useCreateUsedKioskoContext } from "./provider/createUsedKiosko.provider";
import CreateSimplyComponent from "./simply/create-simply.component";
import CreateSimplyKioskoProvider from "./simply/provider/createSimplyKiosko.provider";

const CreateKioskoComponent = () => {
  const { step } = useCreateKioskoContext();
  const { step: stepNews } = useCreateNewsKioskoContext();
  const { step: stepUsed } = useCreateUsedKioskoContext();

  return (
    <>
      {step < 5 ? (
        <div
          className={`mx-auto w-11/12 md:w-2/3 lg:px-10 ${step !== 3 && "rounded-xl bg-white py-5 shadow-xl"}`}
        >
          <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
            {step === 1 && <LoginStepComponent />}
            {step === 2 && <Code2FAStepComponent />}
            {step === 3 && <SelectFlowComponent />}
            {step === 4 && <RecoverStep />}
          </div>
        </div>
      ) : (
        <div
          className={`flex w-full md:mt-20 md:flex-col lg:mt-20 xl:mt-20 xl:flex-row 2xl:mt-0 ${stepUsed === 3 && "md:mt-96 lg:mt-96 xl:mt-80"} ${stepNews === 2 && "md:mt-96 lg:mt-96 xl:mt-80"}`}
        >
          <div className="w-full rounded-xl bg-white py-5 shadow-xl md:-mt-1 lg:px-10 xl:mt-10">
            <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
              <CreateSimplyKioskoProvider>
                <CreateSimplyComponent />
              </CreateSimplyKioskoProvider>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateKioskoComponent;
